// extracted by mini-css-extract-plugin
export var modal = "_te-0";
export var table = "_te-1";